
import React from 'react';
import { cn } from '@/lib/utils';
import { useIsMobile } from '@/hooks/use-mobile';

interface ResponsiveTableProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  compact?: boolean;
  autoHeight?: boolean;
  maxHeight?: string;
}

export function ResponsiveTable({ 
  children, 
  className,
  compact = false,
  autoHeight = false,
  maxHeight,
  ...props 
}: ResponsiveTableProps) {
  const isMobile = useIsMobile();
  
  return (
    <div 
      className={cn(
        isMobile ? "overflow-x-auto -mx-4 px-4 pb-2" : "",
        compact && isMobile ? "scale-95 transform-gpu origin-left" : "",
        autoHeight ? "h-auto" : "",
        maxHeight ? `max-h-[${maxHeight}]` : "",
        "relative",
        className
      )} 
      {...props}
    >
      {/* Fade indicators for horizontal scroll */}
      {isMobile && (
        <>
          <div className="absolute top-0 bottom-0 left-4 w-4 bg-gradient-to-r from-background to-transparent pointer-events-none z-10" />
          <div className="absolute top-0 bottom-0 right-4 w-4 bg-gradient-to-l from-background to-transparent pointer-events-none z-10" />
        </>
      )}
      {children}
    </div>
  );
}
